<h2 mat-dialog-title>Report Offensive</h2>
<div mat-dialog-content class="review-report-offensive__message">
  To report this {{ offensiveType }} as being offensive, please click the Report button below or the Cancel button to go back.<br /><br />
  Some examples of offensive content include vulgar language, inappropriate references, obscene content and profanity.<br /><br />
  AOPA Staff will review the reported {{ offensiveType }} and take appropriate action.<br /><br />
</div>
<div mat-dialog-actions>
  <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" (click)="onNoClick()" cdkFocusInitial>Cancel</button>
  <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" [mat-dialog-close]="true" >Report</button>
</div>
